import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { RequiredInput } from './input'
import { DatePicker } from './date-picker'

export type PersonalInfo = {
  firstName: string;
  lastName: string;
  dateOfBirth: Date | null;
  pesel: string;
}

export interface PersonalFormProps {
  value: PersonalInfo;
  onChange: (person: PersonalInfo) => void;
  showError?: boolean;
  onErrorChange: (error: boolean) => void;
  disabled?: boolean;
}

export const PersonalForm: React.FC<PersonalFormProps> = function (props) {
  const { value: person, onChange, showError = false, onErrorChange, disabled = false } = props
  const [firstNameError, setFirstNameError] = useState(true)
  const [lastNameError, setLastNameError] = useState(true)
  const [peselError, setPeselError] =useState(true)

  function validate (person: PersonalInfo): boolean {
    setFirstNameError(!person.firstName)
    setLastNameError(!person.lastName)
    setPeselError(!person.pesel || person.pesel.length !== 11)

    const error = !person.firstName || !person.lastName || !person.dateOfBirth || person.pesel.length !== 11 || !person.pesel
    onErrorChange(error)
    return error
  }

  function update (key: string, value: any): void {
    const newPerson = {
      ...person,
      [key]: value
    }
    validate(newPerson)
    onChange(newPerson)
  }
  return (
    <Grid container spacing={2} direction="column" >
      <Grid item xs>
        <RequiredInput disabled={disabled} value={person.firstName} onChange={value => update('firstName', value)} label='Imię' error={showError && firstNameError} />
      </Grid>
      <Grid item xs>
        <RequiredInput disabled={disabled} value={person.lastName} onChange={value => update('lastName', value)} label='Nazwisko' error={showError && lastNameError} />
      </Grid>
      <Grid item xs>
        <DatePicker disabled={disabled} value={person.dateOfBirth} onChange={value => update('dateOfBirth', value)} label='Data urodzenia'/>
      </Grid>
      <Grid item xs>
        <RequiredInput disabled={disabled} value={person.pesel} label="Numer PESEL" onChange={value => update('pesel', value)} error={showError && peselError} />
      </Grid>
    </Grid>
  )
}
